import type { ChartConfiguration } from 'chart.js'
import units from '../data/graphic_units.json'
import type { components } from '@/types/gateway_schema'
import { Droplet, Sun, Trash2, Fan, HardDrive } from 'lucide-vue-next'
import type { Component } from 'vue'

export type ApplicationDevice = components['schemas']['SopravisionDeviceDTO']

export const units_scales = Object.fromEntries(
  Object.entries(units).map(([key, value]) => [
    key,
    {
      position: value.position,
      axis: 'y'
    }
  ])
)

export function get_device_name(id: string): string {
  const names = new Map([
    ['kipo', 'Kipopluie'],
    ['sola', 'Soprasolar'],
    ['aqua', 'Aquasmart']
  ])

  return names.get(id) ?? 'Équipment introuvable'
}

export function get_device_icon(device: ApplicationDevice): Component {
  const icons = new Map<string, Component>()
  icons.set('HUUMBOX', Droplet)
  icons.set('SOLAIRE', Sun)
  icons.set('XLSX', Trash2)
  icons.set('JEEDOM', Fan)

  const icon = icons.get(device.type)
  if (icon) {
    return icon
  }

  return HardDrive
}

export const device_chart: ChartConfiguration = {
  type: 'line',
  data: { datasets: [] },
  options: {
    responsive: true,
    scales: {
      x: {
        type: 'time',
        time: {
          minUnit: 'day',
          tooltipFormat: 'DD/MM/YYYY',
          displayFormats: {
            day: 'DD/MM'
          }
        },
        title: {
          text: 'test'
        }
      },
      x2: {
        type: 'time',
        time: {
          minUnit: 'day',
          tooltipFormat: 'DD/MM/YYYY',
          displayFormats: {
            day: 'DD/MM'
          }
        },
        title: {
          text: 'test'
        }
      },
      ...units_scales
    }
  }
}
